<section>
  <div class="faq-section">
    <h1>Frequently asked questions </h1>
    <h2>Device management program </h2>
    <p>View frequently asked questions (FAQs) about how to use the device management program to benefit your company.</p>
    <app-accordion [accordion]="generalFaq" [accordionController] = true [accordionHeading]="faqHeadings[0]">
      <!--  <app-accordion-list *ngFor="let faq of faqValues.faq; let i = index" [item]='i' [count]='faqValues.faq.length' [occontrol]="false" [accheading] = 'faq.question'> -->
      <app-accordion-list *ngFor="let faqs of generalFaq; let i = index" [option]='faqs'#target id={{i}}  [isSubAccordion] = true >
        <div tabindex="0" class="row acc-content " [innerHTML]="faqs.answer"  > </div>
        <div *ngIf="faqs.article" class="padding">
          <!-- <div *ngFor="let links of  faqs.article; let j = index"> -->
            <div *ngIf="faqs.article.articleType == 'pdf'">
             <a class="link" href="javascript:void(0)" (click)="openOverviewModal(faqs.article.articleUrl, faqs.article.articleIsTask)"> {{ faqs.article.articleName}} </a>
              <div *ngIf='showOverviewModal'> 
                <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass" id="faqLinkPopup">
                  <div class="modal-header">
                    <h2 id='modalHeading' tabindex="0"></h2>
                  </div>
                  <div class="corner-button">
                    <button class="close" aria-label="Close" (click)="closeOverviewModal(true)">x</button>
                  </div>
                  <iframe width="100%" height="350" [src]="articleUrl" target="_blank"></iframe>
                  <div class="text-right modal-footer">
                    <div class="button-group">
                      <div *ngIf="articleIsTask">
                        <button (click)="closeOverviewModal(true)" class="btn btn-secondary pull-right" attr.aria-label="Continue"> Begin Task</button>
                        <a href="javascript:void(0)" class="btn btn-link" (click)="closeOverviewModal(true)" attr.aria-label="Cancel">Cancel</a>
                      </div>
                      <div *ngIf="!articleIsTask">
                        <button (click)="closeOverviewModal(true)" class="btn btn-secondary pull-right" attr.aria-label="OK"> OK</button>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </app-modal>
              </div>
            </div>
            <div *ngIf="faqs.article.type == 'video'">
              <att-gvp [attr.video]="articlelinks.url"></att-gvp>
            </div>
          <!-- </div> -->
        </div>
      </app-accordion-list>
    </app-accordion>

    <!-- <app-accordion [accordion]="samsungFaq" [accordionController] = true [accordionHeading]="faqHeadings[1]"> -->
      <!--  <app-accordion-list *ngFor="let faq of faqValues.faq; let i = index" [item]='i' [count]='faqValues.faq.length' [occontrol]="false" [accheading] = 'faq.question'> -->
      <!-- <app-accordion-list *ngFor="let faqs of samsungFaq; let i = index" [option]='faqs'#target id={{i}}  [isSubAccordion] = true >
        <div tabindex="0" class="row acc-content " [innerHTML]="faqs.answer"  > </div>
        <div *ngIf="faqs.article" class="padding"> -->
          <!-- <div *ngFor="let links of  faqs.article; let j = index"> -->
            <!-- <div *ngIf="faqs.article.articleType == 'pdf'">
             <a class="link" href="javascript:void(0)" (click)="openOverviewModal(faqs.article.articleUrl, faqs.article.articleIsTask)"> {{ faqs.article.articleName}} </a>
              <div *ngIf='showOverviewModal'> 
                <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass" id="faqLinkPopup">
                  <div class="modal-header">
                    <h2 id='modalHeading' tabindex="0"></h2>
                  </div>
                  <div class="corner-button">
                    <button class="close" aria-label="Close" (click)="closeOverviewModal(true)">x</button>
                  </div>
                  <iframe width="100%" height="350" [src]="articleUrl" target="_blank"></iframe>
                  <div class="text-right modal-footer">
                    <div class="button-group">
                      <div *ngIf="articleIsTask">
                        <button (click)="closeOverviewModal(true)" class="btn btn-secondary pull-right" attr.aria-label="Continue"> Begin Task</button>
                        <a href="javascript:void(0)" class="btn btn-link" (click)="closeOverviewModal(true)" attr.aria-label="Cancel">Cancel</a>
                      </div>
                      <div *ngIf="!articleIsTask">
                        <button (click)="closeOverviewModal(true)" class="btn btn-secondary pull-right" attr.aria-label="OK"> OK</button>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </app-modal>
              </div>
            </div>
            <div *ngIf="faqs.article.type == 'video'">
              <att-gvp [attr.video]="articlelinks.url"></att-gvp>
            </div> -->
          <!-- </div> -->
        <!-- </div> -->
        <!-- Sub accordion Start Here  -->
        <!--<app-accordion [accordion]="faq.description.subfaq"  [accordionController] = false  >
          <app-accordion-list *ngFor="let sf of faq.description.subfaq; let i = index" [option]='sf' [isSubAccordion] = false > 
            <div class="acc-content"> {{sf.description.answer}} </div>
            <div *ngIf="sf.description.links">
              <div *ngFor="let links of  sf.description.links; let j = index">
                <div *ngIf="links.type == 'pdf'">
                  <a href='{{links.url}}'> {{links.name}} </a>
                </div>
                <div *ngIf="links.type == 'video'">
                  <app-video [url]='links.url' [idx]='j'></app-video>
                </div>
              </div>
            </div>
          </app-accordion-list>
        </app-accordion>  -->
        <!-- Sub accordion ENds here -->
      <!-- </app-accordion-list>
    </app-accordion> --> 

    <app-accordion [accordion]="androidFaq" [accordionController] = true [accordionHeading]="faqHeadings[1]">
      <!--  <app-accordion-list *ngFor="let faq of faqValues.faq; let i = index" [item]='i' [count]='faqValues.faq.length' [occontrol]="false" [accheading] = 'faq.question'> -->
      <app-accordion-list *ngFor="let faqs of androidFaq; let i = index" [option]='faqs'#target id={{i}}  [isSubAccordion] = true >
        <div tabindex="0" class="row acc-content " [innerHTML]="faqs.answer"  > </div>
        <div *ngIf="faqs.article" class="padding">
          <!-- <div *ngFor="let links of  faqs.article; let j = index"> -->
            <div *ngIf="faqs.article.articleType == 'pdf'">
             <a class="link" href="javascript:void(0)" (click)="openOverviewModal(faqs.article.articleUrl, faqs.article.articleIsTask)"> {{ faqs.article.articleName}} </a>
              <div *ngIf='showOverviewModal'> 
                <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass" id="faqLinkPopup">
                  <div class="modal-header">
                    <h2 id='modalHeading' tabindex="0"></h2>
                  </div>
                  <div class="corner-button">
                    <button class="close" aria-label="Close" (click)="closeOverviewModal(true)">x</button>
                  </div>
                  <iframe width="100%" height="350" [src]="articleUrl" target="_blank"></iframe>
                  <div class="text-right modal-footer">
                    <div class="button-group">
                      <div *ngIf="articleIsTask">
                        <button (click)="closeOverviewModal(true)" class="btn btn-secondary pull-right" attr.aria-label="Continue"> Begin Task</button>
                        <a href="javascript:void(0)" class="btn btn-link" (click)="closeOverviewModal(true)" attr.aria-label="Cancel">Cancel</a>
                      </div>
                      <div *ngIf="!articleIsTask">
                        <button (click)="closeOverviewModal(true)" class="btn btn-secondary pull-right" attr.aria-label="OK"> OK</button>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </app-modal>
              </div>
            </div>
            <div *ngIf="faqs.article.type == 'video'">
              <att-gvp [attr.video]="articlelinks.url"></att-gvp>
            </div>
          <!-- </div> -->
        </div>
        <!-- Sub accordion Start Here  -->
        <!--<app-accordion [accordion]="faq.description.subfaq"  [accordionController] = false  >
          <app-accordion-list *ngFor="let sf of faq.description.subfaq; let i = index" [option]='sf' [isSubAccordion] = false > 
            <div class="acc-content"> {{sf.description.answer}} </div>
            <div *ngIf="sf.description.links">
              <div *ngFor="let links of  sf.description.links; let j = index">
                <div *ngIf="links.type == 'pdf'">
                  <a href='{{links.url}}'> {{links.name}} </a>
                </div>
                <div *ngIf="links.type == 'video'">
                  <app-video [url]='links.url' [idx]='j'></app-video>
                </div>
              </div>
            </div>
          </app-accordion-list>
        </app-accordion>  -->
        <!-- Sub accordion ENds here -->
      </app-accordion-list>
    </app-accordion>

    <app-accordion [accordion]="abmFaq" [accordionController] = true [accordionHeading]="faqHeadings[2]">
      <!--  <app-accordion-list *ngFor="let faq of faqValues.faq; let i = index" [item]='i' [count]='faqValues.faq.length' [occontrol]="false" [accheading] = 'faq.question'> -->
      <app-accordion-list *ngFor="let faqs of abmFaq; let i = index" [option]='faqs'#target id={{i}}  [isSubAccordion] = true >
        <div *ngIf="faqs.question != 'My organization doesn\'t have an Apple Business account (also known as an Apple Org ID).  What should I do?'">
          <div tabindex="0" class="row acc-content " [innerHTML]="faqs.answer"> </div>
        </div>
        <div *ngIf="faqs.question === 'My organization doesn\'t have an Apple Business account (also known as an Apple Org ID).  What should I do?' && (showEnrollLink && showABMFEOption)"  tabindex="0" class="row acc-content" [innerHTML]="faqs.answer">
        </div>
        <div *ngIf="faqs.question === 'My organization doesn\'t have an Apple Business account (also known as an Apple Org ID).  What should I do?' && (showABMAnswer)"  tabindex="0" class="row acc-content" [innerHTML]="faqs.enrollAnswer">
        </div>
        <div *ngIf="faqs.article" class="padding">
          <!-- <div *ngFor="let links of  faqs.article; let j = index"> -->
            <div *ngIf="faqs.article.articleType == 'pdf'">
             <a class="link" href="javascript:void(0)" (click)="openOverviewModal(faqs.article.articleUrl, faqs.article.articleIsTask)"> {{ faqs.article.articleName}} </a>
              <div *ngIf='showOverviewModal'> 
                <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass" id="faqLinkPopup">
                  <div class="modal-header">
                    <h2 id='modalHeading' tabindex="0"></h2>
                  </div>
                  <div class="corner-button">
                    <button class="close" aria-label="Close" (click)="closeOverviewModal(true)">x</button>
                  </div>
                  <iframe width="100%" height="350" [src]="articleUrl" target="_blank"></iframe>
                  <div class="text-right modal-footer">
                    <div class="button-group">
                      <div *ngIf="articleIsTask">
                        <button (click)="closeOverviewModal(true)" class="btn btn-secondary pull-right" attr.aria-label="Continue"> Begin Task</button>
                        <a href="javascript:void(0)" class="btn btn-link" (click)="closeOverviewModal(true)" attr.aria-label="Cancel">Cancel</a>
                      </div>
                      <div *ngIf="!articleIsTask">
                        <button (click)="closeOverviewModal(true)" class="btn btn-secondary pull-right" attr.aria-label="OK"> OK</button>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </app-modal>
              </div>
            </div>
            <div *ngIf="faqs.article.type == 'video'">
              <att-gvp [attr.video]="articlelinks.url"></att-gvp>
            </div>
          <!-- </div> -->
        </div>
        <!-- Sub accordion Start Here  -->
        <!--<app-accordion [accordion]="faq.description.subfaq"  [accordionController] = false  >
          <app-accordion-list *ngFor="let sf of faq.description.subfaq; let i = index" [option]='sf' [isSubAccordion] = false > 
            <div class="acc-content"> {{sf.description.answer}} </div>
            <div *ngIf="sf.description.links">
              <div *ngFor="let links of  sf.description.links; let j = index">
                <div *ngIf="links.type == 'pdf'">
                  <a href='{{links.url}}'> {{links.name}} </a>
                </div>
                <div *ngIf="links.type == 'video'">
                  <app-video [url]='links.url' [idx]='j'></app-video>
                </div>
              </div>
            </div>
          </app-accordion-list>
        </app-accordion>  -->
        <!-- Sub accordion ENds here -->
      </app-accordion-list>
    </app-accordion>

  </div>
</section>